var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VideoNavigationEditor',{ref:"videoNavigationEditorRef",staticClass:"video-navigation-editor",attrs:{"appendToBody":"","rootCompanyId":_vm.forms.rootCompanyId,"languageCode":_vm.forms.language,"data":_vm.forms.videoNavigationList}})
}
var staticRenderFns = []

export { render, staticRenderFns }